import "slick-carousel";
import {selectJs} from "./select";
import { convertToRadios } from "./color-radios";

function initJS() {
  $(".wk-row .side-image .wk-image").each(function() {
    const $this = $(this);
    const productUrl = $this.data("product") + ".js";

    $.ajax({
      url: productUrl,
      dataType: "json"
    }).done(data => {
      data.images.map(image => {
        const imageUrl = Shopify.Image.getSizedImageUrl(image, "820x");
        const imageMarkup = `
          <div class="wk-variant-link wk-content">
            <img class="wk-variant-image"
               src="${imageUrl}" />
          </div>
        `;
        $this.append(imageMarkup);
      });

      $this.slick({
        dots: true,
        prevArrow: '<button type="button" class="slick-prev"></button>',
        nextArrow: '<button type="button" class="slick-next"></button>'
      });
    });
  });

  $(".wk-product-options").each(function() {
    const $this = $(this);
    $this.find(".selector-wrapper").each(function() {
      const $self = $(this);
      const $label = $self.find("label");
      if ($label.text() === "Color") {
        $self.hide();
        convertToRadios($label.next(), $this);
      }
    });
  });

  $(".selector-wrapper select").selectric({
    arrowButtonMarkup: '<b class="button"></b>',
    allowWrap: false,
    expandToItemText: true
  });
}

$(window).on("load", function() {
  Appmate.wk.$(document).ready(function() {
    initJS();
  });
});

$(document).on("updateWishlist", function() {
  initJS();
});



// WEBPACK FOOTER //
// ../assets/js/wishlist.js